import { render } from "./InStockDetail.vue?vue&type=template&id=12c74085&scoped=true"
import script from "./InStockDetail.vue?vue&type=script&lang=js"
export * from "./InStockDetail.vue?vue&type=script&lang=js"

import "./InStockDetail.vue?vue&type=style&index=0&id=12c74085&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c74085"],['__file',"src/views/h5/luqiao/stockOrder/inStock/InStockDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12c74085"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12c74085', __exports__)) {
    api.reload('12c74085', __exports__)
  }
  
  module.hot.accept("./InStockDetail.vue?vue&type=template&id=12c74085&scoped=true", () => {
    api.rerender('12c74085', render)
  })

}


export default __exports__